import { ModalBody, ModalHeader } from 'UIKit/AlchemyModal'
import { ModalSizeModeEnum } from 'UIKit/AlchemyModal/Modal'
import { Token } from 'config/types'
import useFullSizeModalRouteUpdater from 'hooks/useFullSizeModalRouteUpdater'
import { PAYMENT_MODAL_THEME, StylePaymentModal } from '../components/styles'
import TipForm from './components/TipForm'

interface TipProps {
  onDismiss: () => void
  initialToken?: Token
  userName: string
}

const Tip: React.FC<TipProps> = ({ onDismiss, initialToken, userName }) => {
  const onBack = useFullSizeModalRouteUpdater('Tip', onDismiss)

  return (
    <StylePaymentModal
      sizeMode={ModalSizeModeEnum.Full}
      colorTheme={PAYMENT_MODAL_THEME}
      disableClose
      id="payment"
      onDismiss={onBack}
    >
      <ModalHeader
        hideStroke
        useBackIcon
        onBack={onBack}
        titleAlign="center"
        colorTheme={PAYMENT_MODAL_THEME}
        title="Tip"
        hideClose
      />
      <ModalBody>
        <TipForm initialToken={initialToken} userName={userName} onDismiss={onBack} />
      </ModalBody>
    </StylePaymentModal>
  )
}

export default Tip
